import { Controller } from "@hotwired/stimulus";

// Loads the public Chartkick bundle shortly before the chart section is visible.
export default class extends Controller {
  static values = { src: String };

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadCharts();
      },
      { rootMargin: "300px" },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  async loadCharts() {
    if (this.loading) return;

    this.loading = true;
    this.observer?.disconnect();

    try {
      await import(this.srcValue);
    } catch (error) {
      this.loading = false;
      console.error("Unable to load public charts", error);
    }
  }
}
